/*
 * 创建webworker
 */
export function createWorker(f) {
    const blob = new Blob([`
    self.addEventListener('message', ${f.toString()}, false);
    `]);
    const url = window.URL.createObjectURL(blob);
    const worker = new Worker(url);
    return worker;
}
